import { CToken } from '../function/axios'
import globalCookies from '../function/cookies'
import { getAppConfigValue } from '../function/configuration'


export let cancelCheckToken
export let cancelAddEmail
export let cancelGetCreditCard
export let cancelgetUser

export default {
  login: (email,password) => {
    return window.ccpAxios.post('/api/login',{
      type: 'login',
      attributes: {
        email,
        password
      }
    })
  },
  getTwoFactorSettings: () => {
    return window.ccpAxios.get('/api/user/two-factor')
  },
  createTwoFactor: () => {
    return window.ccpAxios.get('/api/two-factor/create')
  },
  verifyTwoFactor: (two_factor_token) => {
    return window.ccpAxios.post('/api/two-factor',{
      type: "two-factor-authentication",
      attributes: {
        two_factor_token
      }
    })
  },
  logout: () => {
    return window.ccpAxios.delete('/api/logout')
  },
  register: (carttoken,payload) =>{
    return window.ccpAxios.post(`/api/user/create/${carttoken}`,{
      ...payload
    })
  },
  checkToken: () =>{
    const access_token = globalCookies.get('access_token')
    if(access_token){
      window.ccpAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    }
    return window.ccpAxios.get('/api/check-token/',{
      cancelToken: new CToken (function(c){
        cancelCheckToken = c
      })
    })
  },
  getUser: () => {
    return window.ccpAxios.get('/api/user',{
      cancelToken: new CToken (function(c){
        cancelgetUser = c
      })
    })
  },
  setAccessToken: (access_token) => {
    if(access_token){
      let baseURL = getAppConfigValue('cookie_domain') || '.teamgoblins.com'
      const {cookie_domain} = window.app_config
      if(cookie_domain){
        baseURL = cookie_domain
      }
      if(process.env.NODE_ENV === 'development'){
        globalCookies.set('access_token',access_token)
      }else{
        if(baseURL){
          globalCookies.set('access_token',access_token,{
            path:"/",
            domain: baseURL
          })
        }else{
          globalCookies.set('access_token',access_token)
        }
      }
      window.ccpAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    }
  },
  removeAccessToken: () => {
    window.ccpAxios.defaults.headers.common['Authorization'] = '';
  },
  validateAccountDetails: (payload) => {
    return window.ccpAxios.post('/api/user/validate',{
      ...payload
    })
  },
  updateCartUserDetails: (account_id,user_id,carttoken) => {
    return window.ccpAxios.post(`/api/cart/update-user/${carttoken}`,{
      account_id,
      user_id
    })
  },
  getCreditCard: () => {
    return window.ccpAxios.get('/api/user/credit-card',{
      cancelToken: new CToken (function(c){
        cancelGetCreditCard = c
      })
    })

  },
  getInvoice: (invoiceid) => {
    return window.ccpAxios.get(`/api/user/invoice/${invoiceid}`)
  },
  addEmail: (email,carttoken) => {
    return window.ccpAxios.post(`/api/user/add-email/${carttoken}`,{
      email
    },{
      cancelToken: new CToken(function(c){
        cancelAddEmail = c
      })
    })
  },
  listAccounts: () =>{
    return window.ccpAxios.get(`/api/user/account-list`)
  },
  setAccountForlogin : (id) =>{
    return window.ccpAxios.post(`/api/user/select-account/${id}`)
  },
  getAccountCredit : () =>{
    return window.ccpAxios.get(`/api/account/account-credit`)
  },
  leaveFeedback : (attributes) => {
    return window.ccpAxios.post('/api/support/e-ticket', {
      type: "e-ticket",
      attributes
    })
  }
}